import { useTranslations } from 'next-intl';
import { Icon } from '@/components/entities/Sprite';
import { Button } from '@/components/ui/Button/button';
import openModal from '@/modals/utils/openModal';
import { cn } from '@/utils/cn';

interface Props {
  className?: string;
}

const Support = ({ className }: Props) => {
  const t = useTranslations('footer');
  return (
    <Button
      variant="secondary"
      iconBefore={<Icon name="support-navbar" className="size-6 text-white" />}
      className={cn('py-2.5 px-6 gap-1.5 paragraph-s-medium -mt-1.25', className)}
      onClick={() => openModal('support')}
    >
      {t('support')}
    </Button>
  );
};

export default Support;
